import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { BdResource } from '@bindoc-projects/resource-domain-lib';
import {
  BD_RESOURCES_LIST_OPTIONS_DEFAULT,
  BdResourcesListConfig,
} from './list-options.model';
import { TableModule } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { Router, RouterLink } from '@angular/router';
import { ButtonDirective } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';

@Component({
  selector: 'bd-resources-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-table
      #resourcesTable
      [value]="resources()"
      [paginator]="true"
      [rows]="25"
      [sortField]="'modifiedDate'"
      [sortOrder]="-1"
      [rowsPerPageOptions]="[25, 50, 100]"
      [globalFilterFields]="['name', 'labels', 'modifiedDate']"
      selectionMode="single"
      dataKey="id"
      class="p-datatable-sm"
      [showPageLinks]="false"
      [showFirstLastIcon]="false"
      (selectionChange)="onRowSelect($event)"
    >
      <ng-template #caption>
        <div class="flex flex-row justify-end">
          <p-iconfield
            iconPosition="right"
            class="basis-full md:basis-1/4 ml-auto"
          >
            <input
              pInputText
              type="text"
              fluid
              (input)="
                resourcesTable.filterGlobal(getInputValue($event), 'contains')
              "
              i18n-placeholder
              placeholder="Suchen"
            />
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sort-icon field="name"></p-sort-icon>
          </th>
          @if (options().showLabelsColumn) {
            <th class="w-1/5 xl:w-1/4">Labels</th>
          }
          <th class="w-40 xl:w-1/5" pSortableColumn="modifiedDate">
            <span i18n>Letzte Änderung</span>
            <p-sort-icon field="modifiedDate"></p-sort-icon>
          </th>
          <th class="w-12"></th>
        </tr>
      </ng-template>
      <ng-template #body let-resource>
        <tr
          [pSelectableRow]="resource"
          [pSelectableRowDisabled]="options().disableFnc(resource)"
        >
          <td>{{ resource.name }}</td>
          @if (options().showLabelsColumn) {
            <td>
              {{
                resource.labels && resource.labels.length > 0
                  ? resource.labels.join(', ')
                  : ''
              }}
            </td>
          }
          <td>{{ resource.modifiedDate | date: 'short' }}</td>
          <td>
            @if (!options().disableFnc(resource)) {
              <a
                pButton
                size="small"
                text
                rounded
                severity="secondary"
                aria-label="Details öffnen"
                title="Details öffnen"
                [routerLink]="options().detailLinkFnc(resource)"
                iconOnly
                ><i class="pi pi-external-link" aria-hidden="true"></i>
              </a>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="4">{{ options().emptyResourcesText }}</td>
        </tr>
      </ng-template>
    </p-table>
  `,
  imports: [
    TableModule,
    DatePipe,
    InputTextModule,
    RouterLink,
    ButtonDirective,
    IconField,
    InputIcon,
  ],
})
export class BdResourcesListComponent {
  readonly options = input<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BdResourcesListConfig<any>
  >(BD_RESOURCES_LIST_OPTIONS_DEFAULT);
  readonly resources = input<BdResource[]>([]);

  private readonly _router = inject(Router);

  public getInputValue(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }

  public onRowSelect(row: BdResource): void {
    this._router.navigate(this.options().detailLinkFnc(row));
  }
}
